
define('actionclick',['require','jquery','underscore'],function (require) {

    'use strict';

    var $ = require('jquery'),
        _ = require('underscore');
    
    // "actionclick" event

    // Special "actionclick" event 
    // filters click events to only call when "enabled" and the event has not been prevented. Also accounts for 
    // modifier keys being pressed (for opening links in a new tab/window)

    var rScriptUrl = /^\s*javascript:/i;

    function actionClickHandler (handler) {
        return function (e) {
            // event is already dead, but we want it to propogate
            if (e.isDefaultPrevented()) {
                return null;
            }
            // let the browser handle opening new tabs/windows - ignore this if there is no href or it is '#'
            if ((e.ctrlKey || e.shiftKey || e.metaKey)) {
                var href = $(e.currentTarget).attr('href');
                if (href && href !== '#') {
                    return null;
                }
            }

            var disabled = !!$(e.currentTarget).closest('.disabled').length;
            var retVal = disabled ? null : handler.apply(this, arguments);
            // allow functions to return true to not prevent the default action
            if (retVal !== true) {
                // if this event was triggered inside of a link with a JavaScript action don't prevent default unless this is disabled; otherwise, it will never execute
                var link = $(e.target).closest('a'),
                    hasJsLink = link.length && rScriptUrl.test(link.attr('href')) && $.contains(e.currentTarget, link[0]);
                if (!hasJsLink || disabled) {
                    e.preventDefault();
                }
            }
            return retVal;
        };
    }

    $.each(['click', 'mousedown'], function (i, sourceEventType) {
        var actionEventType = 'action' + sourceEventType;

        // extend the jQuery functions so it can be used in chainable calls; using all lowercase for consistency with event type names
        $.fn[actionEventType] = function (data, fn) {
            ///<summary>Attach event listeners of the special 'actionclick' type. Same args as .click() (except you can't trigger the event).</summary>
            
            // args and normalization copied from jQuery to mimic behavior of .click(), etc.
            if (!fn) {
                fn = data;
                data = null;
            }

            return this.on(actionEventType, null, data, fn);
        };

        // add to the special events API so it can be used in delegation and other means of event handling
        $.event.special[actionEventType] = {
            setup: function () {
                // prevent actually listening for 'actionclick' events - not necessary because we won't trigger them
                return false;
            },
            add: function (handleObj) {

                // type, data, namespace, handler, selector
                handleObj.handler = _.throttle(actionClickHandler(handleObj.handler), 10);

                updateEventAttachment(this, sourceEventType, handleObj, true);
            },

            remove: function (handleObj) {
                updateEventAttachment(this, sourceEventType, handleObj, false);
            }
        };
    });


    function updateEventAttachment (elem, eventType, handleObj, isAttaching) {
        var eventName = eventType + (handleObj.namespace ? '.' + handleObj.namespace : '');
        // update the actual click events
        var args = [eventName, handleObj.selector, handleObj.data, handleObj.handler];
        args.splice(2, isAttaching ? 0 : 1), // remove data arg if detaching
        elem = $(elem);
        elem[isAttaching ? 'on' : 'off'].apply(elem, args);
    }
});